import { ReduceStore } from "flux/utils";
import AppDispatcher from "../AppDispatcher";
import CurrentUserIdStore from "./CurrentUserIdStore";
import CurrentOrganizationIdStore from "./CurrentOrganizationIdStore";
import RoleStore from "./RoleStore";
import MembershipStore from "./MembershipStore";

class CurrentRoleStore extends ReduceStore {
  getInitialState() {
    return null;
  }

  reduce(state) {
    this.getDispatcher().waitFor([
      CurrentUserIdStore.getDispatchToken(),
      CurrentOrganizationIdStore.getDispatchToken(),
      MembershipStore.getDispatchToken(),
      RoleStore.getDispatchToken(),
    ]);

    if (
      CurrentUserIdStore.hasChanged() ||
      CurrentOrganizationIdStore.hasChanged() ||
      MembershipStore.hasChanged() ||
      RoleStore.hasChanged()
    ) {
      const currentMembership = MembershipStore.getMembership(
        CurrentUserIdStore.getState(),
        CurrentOrganizationIdStore.getState()
      );
      if (currentMembership) {
        return RoleStore.get(currentMembership.role, null);
      }
      return state;
    }

    return state;
  }

  hasAction(actionName) {
    const state = this.getState();
    return state && state.availableActions.indexOf(actionName) >= 0;
  }

  lacksAction(actionName) {
    const state = this.getState();
    return state && !(state.availableActions.indexOf(actionName) >= 0);
  }

  isContentViewer() {
    return this.isViewer() && this.hasAction("content");
  }

  isViewer() {
    return (
      this.lacksAction("tools") &&
      this.lacksAction("matching") &&
      this.lacksAction("crosschannel") &&
      this.lacksAction("syncs")
    );
  }

  isAdmin() {
    return this.hasAction("admin");
  }

  canSaveJobs() {
    return this.isAdmin();
  }

  canViewAllOrgJobs() {
    return this.isAdmin() || this.hasAction("viewalljobs");
  }
}

const instance = new CurrentRoleStore(AppDispatcher);
export default instance;
